export default __webpack_public_path__ + "static/media/location-pin.92565df1.svg";